module.exports = __webpack_public_path__ + "img/a8fac29.svg";